import { compose } from 'redux';
import { connect } from 'react-redux';
import {
    GetDetailEventRequestd,
    ClearGetDetailEvent,
    ClearCreateRoleEvent,
    CreateRoleEventRequest,
} from '../../../actions/EventManagement';
import SettingRoleAdmin from '../../../pages/Admin/EventManagement/SettingRoleAdminDialog';
import withAuth from '../../../common/WithAuth';

const mapStateToProps = (state) => ({
    locale: state.locale.lang.current,
    eventDetail: state.eventManagement.detailEvent.data,
    createRoleEventSuccess: state.eventManagement.createRoleEvent.isSuccess,
    errorsRoleEvent: state.eventManagement.createRoleEvent.errors,
});

const mapDispatchToProps = (dispatch) => ({
    fetchGetDetailEvent: (params) => {
        dispatch(GetDetailEventRequestd(params));
    },
    clearGetDetailEvent: () => {
        dispatch(ClearGetDetailEvent());
    },
    fetchCreateRole: (params) => dispatch(CreateRoleEventRequest(params)),
    clearRoleEvent: () => dispatch(ClearCreateRoleEvent()),
});

export default compose(
    withAuth,
    connect(
        mapStateToProps,
        mapDispatchToProps,
    ),
)(SettingRoleAdmin);
